export class ContratacionSEACE {

    cAnocon: string;
    cValretOrig: string;
    descripcion: string;
    entidad: string;
    modalidadSeleccion: string;
    moneda: string;
    normativaAplicable: string;
    nroExpediente: number;
    objeto: string;
    procesosel: string;
    ruc: string;
    tipoProceso: string;

    flgSeleccionar: boolean;

    // cAnoconFin:string;

    // id_proceso_selec:string;
    // id_modalidad:string;
    // id_convocatoria:string;
    // id_tipo_compra:string;
    // cod_snip:string;
    // departamento:string;
    // provincia:string;
    // distrito:string;
    // dsc_contratacion:string;
    // dsc_tipo_selec:string;
    // dsc_anio:string;
    // dsc_modalidad:string;
    // dsc_tipo_compra:string;
    // valor_estimado_referencial:string;

    // num_item:Number;
    // nomenclatura:string;
    // desc_objeto:string;
    // valor_referencial:string;
    // normativa_aplicable:string;
    // tipo_seleccion:string;
    // version_seace:string;
    // modalidad_seleccion:string;
    // identificador_convocatoria:string;
    // anho_convocatoria:string;
    // tipo_compra:string;
    // codigo_snip:string;
    // entidad_convocante:string;
    // pagina_web:string;
    // direccion_legal:string;
    // telefono_entidad:string;
    // objeto_contratacion:string;
    // monto_derecho:string;
    // fecha_hora_publicacion:string;
    // valor_estimado:string;
    // moneda:string;
    // flgSeleccionar: boolean;




    // entidad_publica:string;
    // id_anio:string;
    // id_contratacion:string;
    // id_tipo_selec:string;
    // num_ruc:string;

    // num_seleccion:string;

    // cod_departamento:string;
    // cod_provincia:string;
    // cod_distrito:string;


}
